import { render, staticRenderFns } from "./configLabel.vue?vue&type=template&id=0313315c&scoped=true"
import script from "./configLabel.vue?vue&type=script&lang=js"
export * from "./configLabel.vue?vue&type=script&lang=js"
import style0 from "./configLabel.vue?vue&type=style&index=0&id=0313315c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313315c",
  null
  
)

export default component.exports